import { ICategoryType } from '@introspection/index';
import { Inject, Injectable } from '@rxdi/core';
import { html } from '@rxdi/lit-html';
import { ModalService } from '@rxdi/ui-kit/modal';
import { StudioModalStyle } from '@shared/styles/modal.styles';
import { Observable } from 'rxjs';

/**
 * The site's dialogs, all in the studio look (StudioModalStyle). Each resolves
 * with the result, or with null when cancelled - callers filter it out.
 */
@Injectable()
export class ModalViewService {
  @Inject(ModalService)
  private modalService: ModalService;

  openSelectCategoryModal(model = null, categories: ICategoryType[]): Observable<Pick<ICategoryType, 'id'>> {
    return this.modalService.openCustomModal(
      {
        style: StudioModalStyle,
        template: html`<category-forms
          .model=${model}
          .categories=${categories}
          @submitted=${(e: CustomEvent<Pick<ICategoryType, 'id'>>) => this.modalService.close(e.detail)}
          @cancelled=${() => this.modalService.close(null)}
        ></category-forms>`,
      },
      { backdropClose: true }
    );
  }

  openCreateCategoryModal(model = null, categories: ICategoryType[]): Observable<ICategoryType> {
    return this.modalService.openCustomModal(
      {
        style: StudioModalStyle,
        template: html`<create-category-forms
          .model=${model}
          .categories=${categories}
          @submitted=${(e: CustomEvent<ICategoryType>) => this.modalService.close(e.detail)}
          @cancelled=${() => this.modalService.close(null)}
        ></create-category-forms>`,
      },
      { backdropClose: true }
    );
  }
}
